import { Button, makeStyles, useTheme } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { styles } from './timeoutError.styles';

export interface TimeoutErrorProps {
  onRefresh?: () => void;
}

export const TimeoutError: React.FC<TimeoutErrorProps> = ({ onRefresh }) => {
  const [t] = useTranslation(['httpErrors']);
  const currentTheme = useTheme();
  const useStyles = makeStyles(styles(currentTheme));
  const classes = useStyles();

  return (
    <div className={classes.errorContainer}>
      <div className={classes.errorCode}>
        <img
          alt="Globaleris"
          src={process.env.PUBLIC_URL + '/images/globaleris-error-timeout.png'}
        />
      </div>
      <div className={classes.errorDescription}>
        <h1>{t('httpErrors:timeout.title')}</h1>
        <p>
          {t('httpErrors:timeout.subtitle')}
          <br />
          {t('httpErrors:timeout.text')}
        </p>

        {onRefresh && (
          <Button
            className={classes.actionButton}
            variant="contained"
            color="primary"
            onClick={() => {
              onRefresh && onRefresh();
            }}
          >
            {t('httpErrors:api.actions.refresh')}
          </Button>
        )}
      </div>
    </div>
  );
};
